import React from 'react';
import { Clock, MapPin, Video, FileText, Download, MessageSquarePlus, CalendarPlus } from 'lucide-react';
export function NextMeeting() {
  return <section className="py-24 px-6 lg:px-8 bg-white" data-id="element-298">
      <div className="max-w-5xl mx-auto" data-id="element-299">
        <div className="text-center mb-12" data-id="element-300">
          <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-4" data-id="element-301">
            Próxima Reunión
          </h2>
          <p className="text-xl text-gray-600 font-medium" data-id="element-302">
            Participa en la próxima reunión comunitaria
          </p>
          <p className="text-gray-500 mt-2" data-id="element-303">
            Tu presencia ayuda a que las necesidades del vecindario sean
            escuchadas.
          </p>
        </div>

        <div className="bg-softblue rounded-3xl overflow-hidden shadow-xl border border-softblue-dark" data-id="element-304">
          <div className="bg-charcoal p-6 md:p-8 text-white flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-305">
            <div className="flex items-center gap-4" data-id="element-306">
              <div className="bg-warm text-charcoal p-4 rounded-2xl flex flex-col items-center justify-center min-w-[80px]" data-id="element-307">
                <span className="text-sm font-bold uppercase" data-id="element-308">JUN</span>
                <span className="text-3xl font-black leading-none" data-id="element-309">12</span>
              </div>
              <div data-id="element-310">
                <h3 className="text-2xl font-bold text-softblue" data-id="element-311">
                  Reunión General Comunitaria
                </h3>
                <p className="text-softblue-dark flex items-center gap-2 mt-1" data-id="element-312">
                  <Clock className="w-4 h-4" data-id="element-313" /> 6:30 PM
                </p>
              </div>
            </div>
            <div className="w-full md:w-auto" data-id="element-314">
              <button className="w-full md:w-auto bg-warm hover:bg-warm-hover text-charcoal font-bold py-3 px-6 rounded-xl transition-colors flex items-center justify-center gap-2" data-id="element-315">
                <CalendarPlus className="w-5 h-5" data-id="element-316" />
                Agregar al calendario
              </button>
            </div>
          </div>

          <div className="p-6 md:p-10" data-id="element-317">
            <div className="grid md:grid-cols-2 gap-8 mb-10" data-id="element-318">
              <div className="space-y-6" data-id="element-319">
                <div className="flex gap-4" data-id="element-320">
                  <MapPin className="w-6 h-6 text-charcoal shrink-0" data-id="element-321" />
                  <div data-id="element-322">
                    <h4 className="font-bold text-charcoal text-lg" data-id="element-323">Lugar</h4>
                    <p className="text-gray-600" data-id="element-324">
                      Sylmar Recreation Center
                      <br data-id="element-325" />
                      13109 Borden Ave, Sylmar, CA 91342
                    </p>
                  </div>
                </div>
                <div className="flex gap-4" data-id="element-326">
                  <Video className="w-6 h-6 text-charcoal shrink-0" data-id="element-327" />
                  <div data-id="element-328">
                    <h4 className="font-bold text-charcoal text-lg" data-id="element-329">
                      Enlace virtual
                    </h4>
                    <a href="#" className="text-sky hover:text-sky-dark underline font-medium" data-id="element-330">
                      Unirse vía Zoom
                    </a>
                  </div>
                </div>
              </div>
              <div className="space-y-6" data-id="element-331">
                <div className="flex gap-4" data-id="element-332">
                  <FileText className="w-6 h-6 text-charcoal shrink-0" data-id="element-333" />
                  <div data-id="element-334">
                    <h4 className="font-bold text-charcoal text-lg" data-id="element-335">Agenda</h4>
                    <a href="#" className="text-sky hover:text-sky-dark underline font-medium" data-id="element-336">
                      Ver Agenda Oficial (PDF)
                    </a>
                  </div>
                </div>
                <div className="flex gap-4" data-id="element-337">
                  <Download className="w-6 h-6 text-charcoal shrink-0" data-id="element-338" />
                  <div data-id="element-339">
                    <h4 className="font-bold text-charcoal text-lg" data-id="element-340">
                      Documentos
                    </h4>
                    <a href="#" className="text-sky hover:text-sky-dark underline font-medium" data-id="element-341">
                      Paquete de la Junta (PDF)
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white p-6 rounded-xl border border-gray-100 mb-8" data-id="element-342">
              <p className="text-gray-700 text-lg text-center" data-id="element-343">
                En esta reunión podrás conocer temas importantes, escuchar
                actualizaciones, enviar comentarios y mantenerte informado sobre
                decisiones que impactan a la comunidad.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row flex-wrap justify-center gap-4" data-id="element-344">
              <button className="flex items-center justify-center gap-2 bg-sky hover:bg-sky-dark text-white px-6 py-3 rounded-lg font-semibold transition-colors" data-id="element-345">
                <FileText className="w-5 h-5" data-id="element-346" /> Ver agenda
              </button>
              <button className="flex items-center justify-center gap-2 bg-charcoal hover:bg-charcoal-light text-white px-6 py-3 rounded-lg font-semibold transition-colors" data-id="element-347">
                <Video className="w-5 h-5" data-id="element-348" /> Unirme por Zoom
              </button>
              <button className="flex items-center justify-center gap-2 bg-white border-2 border-charcoal text-charcoal hover:bg-softblue px-6 py-3 rounded-lg font-semibold transition-colors" data-id="element-349">
                <MessageSquarePlus className="w-5 h-5" data-id="element-350" /> Enviar comentario
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}